var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t高画质·解锁想象\n\t\t")]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t搭载高像素图像传感器，可以得到更高画质的图像，还原更真实的色彩\n\t\t\t清晰锐利的临床图像能够帮助洞察更多黏膜细节\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }